import React from 'react';

const ConfirmDeleteModal = ({ title, message, onConfirm, onClose }) => {
    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', textAlign: 'center', padding: '28px 24px' }}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    backgroundColor: '#fee2e2',
                    color: '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '30px',
                    margin: '0 auto 16px auto',
                    boxShadow: '0 4px 14px rgba(220, 38, 38, 0.15)'
                }}>
                    <i className="fa fa-trash" />
                </div>
                
                <h3 style={{ fontSize: '20px', fontWeight: '800', color: '#0f172a', marginBottom: '8px' }}>
                    {title || 'Confirm Delete'}
                </h3>
                
                <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 24px 0', lineHeight: '1.5' }}>
                    {message || 'Are you sure you want to delete this item? This action cannot be undone.'}
                </p>

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <button
                        type="button"
                        className="admin-btn admin-btn-secondary"
                        onClick={onClose}
                        style={{ flex: 1, padding: '11px 16px', fontWeight: '700', borderRadius: '8px' }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="admin-btn"
                        onClick={onConfirm}
                        style={{
                            flex: 1,
                            padding: '11px 16px',
                            backgroundColor: '#dc2626',
                            color: '#ffffff',
                            border: 'none',
                            fontWeight: '700',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.25)'
                        }}
                    >
                        Yes, Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
